module.exports = __webpack_public_path__ + "static/media/arquivesIcons.bd9077e0.svg";